import React from 'react';

import { Seo, JobsListPage } from 'components';
import vacancies from 'data/vacancies';

const SITE_URL = 'https://www.nimax.ru';
const TITLE = 'Вакансии';
const DESCRIPTION = 'Приглашаем специалистов стать частью команды Nimax.';

/**
 * /jobs/ — список открытых вакансий
 */
export default () => (
  <>
    <Seo
      title="Вакансии агентства Nimax"
      description={`${DESCRIPTION} Открытые вакансии: ${vacancies.map((v) => v.title.toLowerCase()).join(', ')}.`}
      url={`${SITE_URL}/jobs/`}
    />
    <JobsListPage vacancies={vacancies} title={TITLE} description={DESCRIPTION} />
  </>
);
